//********************* GET WORKSPACE USERS ********************************//
// Memoized gudhub.getUserWorkspace() - the whole chat module shares one
// in-flight/resolved fetch instead of each component (sidebar, contacts
// picker, activity feed...) requesting it independently. gudhub.getUserWorkspace()
// caches every returned user into the same storage gudhub.getUserById() reads
// from, so warming this once up front (see gh_conversation.js's onInit) makes
// every later getUserById() call across the chat module resolve from cache.
let workspaceUsersPromise = null;

export function getWorkspaceUsers() {
    if(!workspaceUsersPromise) {
        workspaceUsersPromise = gudhub.getUserWorkspace().catch(err => {
            workspaceUsersPromise = null; // allow a retry on the next call
            throw err;
        });
    }

    return workspaceUsersPromise;
}
